import React, { useState } from "react";
import { motion } from "framer-motion";
import JumpingLetters from "../JumpingLetters";
import TypingLetters from "../TypingLetters";


export default function Contact() {
    const [isHover, setIsHover] = useState(false);
    
    //Web3Forms setup
    const [result ] = React.useState("");
    const [showPopup, setShowPopup] = React.useState(false);
  
    const onSubmit = async (event) => {
      event.preventDefault();
    //   setResult("Sending....");
      const formData = new FormData(event.target);
  
      formData.append("access_key", "da4755b2-abd8-43bc-b31d-2e1dc15c7cc1");
  
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });
  
      const data = await response.json();
  
      if (data.success) {
        // setResult("Form Submitted Successfully");
        setShowPopup(true);
        event.target.reset();
      } else {
        console.log("Error", data);
        // setResult(data.message);
      }
    }

    return (
    <motion.div
        initial={{
            opacity: 0,
            x: -50

        }}
        animate={{
            opacity: 1,
            x: 0,
        }}
        exit={{
            opacity: 0,
            x: 50
        }}
        transition={{
            duration: 0.3,
            ease: "backInOut"
        }}
    >
    
        {/* <h1>CONTACT ME</h1> */}
        {/* <p>EMAIL:</p> */}
        <span className="page-title-animated"
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            style={{ display: "inline-block", cursor: "pointer" }}
        >
            <JumpingLetters text="Contact" isHover={isHover}/>
        </span>


        <div className="page-intro-text">
            <TypingLetters text="Contact me for any inquiries:"/>
        </div>

        <motion.div
            initial={{
                y: -30
            }}
            animate={{
                y: 0
            }}
            transition={{
                type: "spring",
                duration: 1,
                bounce: 0.6
            }}
        
        
        >
            <section className="contact-form">
                <form onSubmit={onSubmit}>
                    <div className="input-box">
                        <label>Name</label>
                        <input type="text" className="field" placeholder="Enter name" name="name" required/>
                    </div>
                    <div className="input-box">
                        <label>Email Address</label>
                        <input type="email" className="field" placeholder="Enter email" name="email" required/>
                    </div>
                    <div className="input-box">
                        <label>Message</label>
                        <textarea name="message" id="" className="field message" placeholder="Enter message" required/>
                    </div>
                    <button type="submit">Send Message</button>
                </form>
            </section>

        </motion.div>
            <span>{result}</span>
        

        {showPopup && (
            <div className="popup-container">
                <div className="success-alert">
                    <button className="close-symbol" onClick={() => setShowPopup(false)}>
                        &times;
                    </button>
                    <span className="material-symbols-outlined">mark_email_read</span>
                    <p>Message sent!</p>
                </div>
            </div>
        )}

    
    </motion.div>
);
}